import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';
import { PageWithLayout } from '../containers/page';

import Isvg from 'react-inlinesvg';

import Slider from "react-slick";

import Range from 'rc-slider/lib/Range';
import Tooltip from 'rc-tooltip';

import 'rc-slider/assets/index.css';

import Switch from 'react-ios-switch';
import Dropzone from 'react-dropzone';
import GridLayout from 'react-grid-layout';

class AddCategoryPage extends Component {
    constructor(props) {
        super(props);

        this.registerSocketIOEvents = this.registerSocketIOEvents.bind(this);
        this.addCategory = this.addCategory.bind(this);

        this.onDrop = this.onDrop.bind(this);
        this.removeImage = this.removeImage.bind(this);

        this.dropzone = React.createRef()

        this.getBase64 = this.getBase64.bind(this);


        this.state = {
            categories: [],
            files: [],

        };
    }


    componentDidMount() {
        this.props.handleLoader(true);

        if (this.props.socketIOClient) {
            this.registerSocketIOEvents();
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.socketIOClient) {
            this.registerSocketIOEvents();
        }
    }

    registerSocketIOEvents() {
        if (this.state._registeredEvents)
            return;

        this.setState({
            _registeredEvents: true
        });



        this.props.socketIOClient.on('addCategory', (data) => {
            this.props.handleLoader(null);

            console.log(data);
            if (data.error) {

            } else if (data.successful) {
                this.props[0].history.push(`/categories`);

            }
        });

        this.props.socketIOClient.on('categories', (data) => {
            this.props.handleLoader(null);

            console.log(data);
            this.setState({
                categories: data
            });
        });


        this.props.socketIOClient.emit('categories', {});





    }


    addCategory() {

        let product = {
            name: this.state.name,
            alias: this.state.alias,
            //shortDescription: this.state.shortDescription,
            //imageBase64: this.state.files[0] ? this.state.files[0] : null,
            category: this.state.category,
        }
        this.props.handleLoader(true);

        this.props.socketIOClient.emit("addCategory", product);

    }


    componentWillUnmount() {
        if (!this.props.socketIOClient) return;
        this.props.socketIOClient.removeAllListeners("categories");
        this.props.socketIOClient.removeAllListeners("addCategory");
    }


    removeImage() {

        this.setState({
            files: [],
        });
    }

    getBase64(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                let encoded = reader.result;
                resolve(encoded);
            };
            reader.onerror = error => reject(error);
        });
    }


    async onDrop(imageFiles) {
        let images = [];

        for (let i = 0; i < imageFiles.length; i++) {
            var base64Image = await this.getBase64(imageFiles[i]);
            images.push(base64Image);

        }

        this.setState({
            files: this.state.files.concat(images),
        })

    }



    render() {

        return (
            <div className="content">
                {

                    (!this.props.uData && !localStorage.uData) && <Redirect to='/login' />

                }
                <div className="panel panel-6">
                    <div className="panel-title">
                        <h1>{this.props.translate('Add new category')}</h1>
                        <h6>{this.props.translate('Fill fields to add catagory')}</h6>

                    </div>
                    <div>


                        <div className="input-wrap">
                            <label>{this.props.translate('Parrent category')}</label>
                            <select value={this.state.category} onChange={(e) => { this.setState({ category: e.target.value }) }}>
                                <option>- - NONE - -</option>
                                {
                                    this.state.categories.map((category) => {
                                        return (
                                            <option value={category._id}>{category.name}</option>
                                        )
                                    }
                                    )}
                            </select>
                        </div>


                        <div className="input-wrap input-wrap-6">
                            <label>{this.props.translate('Name')}</label>
                            <input type="text" value={this.state.name} onChange={(e) => { this.setState({ name: e.target.value, alias: this.props.generateAlias(e.target.value) }) }} />
                        </div>


                        <div className="input-wrap input-wrap-6">
                            <label>{this.props.translate('Alias')}</label>
                            <input type="text" value={this.state.alias} onChange={(e) => { this.setState({ alias: e.target.value }) }} />
                        </div>



                        <div className="input-wrap">
                            <button className="button" onClick={this.addCategory}>{this.props.translate('Add')}</button>
                        </div>


                    </div>
                </div>


            </div>
        );
    }
}

export default PageWithLayout(AddCategoryPage);


// WEBPACK FOOTER //
// ./src/views/addCategoryPage.js